<template lang='pug' src='./app.pug'></template>

<script>
// components
import Navigation from 'components/navigation/navigation'
import BaseBaseAccess from 'components/base-access/index'

export default {
  components: {
    Navigation,
    BaseBaseAccess
  },
  name: 'app'
}
</script>

<-- styles have been moved to main.sass file -->
<style src='../main.sass' lang='sass'></style>



// WEBPACK FOOTER //
// app.vue?16ad96cc